import React, { useState, useEffect } from 'react';
import ActionButtonCard from '../Button/ActionButtonCard';
import Swal from 'sweetalert2'
import { useProvider, Toast } from '../../context/MenuProvider';

const Lembretes = () => {
  const [lembretes, setLembretes] = useState(null);

  const { crud, buscarDadosPorId, salvarDados, hasPerms } = useProvider();
  const { get } = crud || {};

  const carregarModel = (response) => {
    setLembretes(response);
  }

  const updateDados = async (data) => {
    try {
      var atualizado = {
        ...data,
        id: "lembretes_widget"
      }
      await salvarDados('local_registros', atualizado);
    } catch (err) {
      console.error(err);
    }
  };

  const carregarLocal = async () => {
    try {
      const response = await buscarDadosPorId('local_registros', "lembretes_widget");
      if (response) carregarModel(response);
    } catch (err) {
      console.error("Erro ao carregar local:", err);
    } finally {
      buscarLembretes();
    }
  }

  const buscarLembretes = async () => {
    const hoje = new Date().toLocaleDateString('sv-SE'); // "2025-10-23"
    const [ano, mes, dia] = hoje.split('-');
    
    const urls = [];
    const mapKeys = [];

    if (hasPerms('loja.view_venda') && hasPerms('loja.view_pagamento')) {
      urls.push(`/gvendas/pagamentos/?venda__isnull=false&data_do_pagamento=${hoje}&pago=false&expand=venda,cliente&filtros=venda,cliente,id&limit=500`);
      mapKeys.push("receber");

      urls.push(`/gvendas/pagamentos/?venda__isnull=false&pago=false&data_do_pagamento__lt=${hoje}&venda__cliente__ativo=true&expand=venda,cliente&filtros=venda,cliente,id,data_do_pagamento&limit=500`);
      mapKeys.push("atrasados");
    }

    if (hasPerms('loja.view_agenda')) {
      urls.push(`/gvendas/agendas/?data__date__exact=${hoje}&is_cancelado=false&is_realizado=false&limit=1`);
      mapKeys.push("agenda");
    }
    
    if (hasPerms('financas.view_financeiro') && hasPerms('loja.view_pagamento')) {
      urls.push(`/gvendas/pagamentos/?financeiro__isnull=false&data_do_pagamento=${hoje}&pago=false&limit=1`);
      mapKeys.push("pagar");
    }
    
    if(hasPerms('loja.view_clientes')){
      urls.push(`/gvendas/clientes/?numero_de_compras__gt=0&dia_do_aniversario__month__exact=${mes}&dia_do_aniversario__day__exact=${dia}&ativo=true&limit=1`);
      mapKeys.push("aniversario");
    }


    try {
      if (!urls.length) return;
      const response = await get(urls, 'lembretes');
      if (response && response.length) {
        const dados = {};
        mapKeys.forEach((key, index) => {
          let dado = 0;
          if (key === "receber"){
            dado = new Set(response[index]?.results.map(x => x.venda.cliente.id)).size;
          }
          else if (key === "atrasados"){
            const grupos = response[index]?.results.reduce((acc, item) => {
              const data = item.data_do_pagamento;
              if (!acc[data]) acc[data] = new Set();
              acc[data].add(item.venda.cliente.id);
              return acc;
            }, {});
            dado = Object.values(grupos).reduce((sum, set) => sum + set.size, 0);
          }
          else{
            dado = response[index]?.count;
          }
          dados[key] = dado || 0;
        });
        carregarModel(dados);
        updateDados(dados);
      }
    } catch (err) {
      console.error("Erro ao buscar lembretes:", err);
      // Toast.fire({ icon: "error", title: "Falha ao buscar lembretes" });
    }
  };

  useEffect(() => {
    carregarLocal();
  }, []);

  const buttonsConfig = [
    {
      perm: 'loja.view_venda',
      icon: "text-success",
      footer: "Receber",
      span: lembretes?.receber||0,
      to: "/pagamentos/status/hoje",
    },
    {
      perm: 'financas.view_financeiro',
      icon: "text-warning",
      footer: "Pagar",
      span: lembretes?.pagar||0,
      to: "/pagamentos/status/pagar",
    },
    {
      perm: 'loja.view_venda',
      icon: "text-danger",
      footer: "Atrasados",
      span: lembretes?.atrasados||0,
      to: "/pagamentos/status/atrasados",
    },
    {
      perm: 'loja.view_agenda',
      icon: "text-info",
      footer: "Agenda",
      span: lembretes?.agenda||0,
      to: "/agenda",
    },
    {
      perm: "loja.view_clientes", // sempre aparece
      icon: "text-secondary",
      footer: "Aniversário",
      span: lembretes?.aniversario||0,
      to: "/clientes/aniversarios",
    },
  ];

  return (
    <div>
      <div className="row align-items-center" data-aos="fade-up">
        {buttonsConfig.map((btn, index) => {
          if (btn.perm && !hasPerms(btn.perm)) return null;
          return (
            <ActionButtonCard
              key={index}
              icon={btn.icon}
              footer={btn.footer}
              span={btn.span}
              to={btn.to}
            />
          );
        })}
      </div>
    </div>
  );
}

export default Lembretes;